const BASE = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`

async function call(fn, body) {
  const res = await fetch(`${BASE}/${fn}`, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify(body),
  })
  const json = await res.json()
  if (!res.ok) throw new Error(json.error ?? 'Request failed')
  return json
}

export const getDisplayData     = (token)               => call('get-display-data',    { device_token: token })
export const verifyDisplayPin   = (token, userId, pin)  => call('verify-display-pin',  { device_token: token, user_id: userId, pin })
export const displayAction      = (token, memberId, action, targetId) =>
  call('display-action', { device_token: token, member_id: memberId, action, target_id: targetId })
